import { z } from 'zod';
import { ID } from '../../utils/codecUtils';
import { PaginationQuery } from '../../utils/listQuery';
import { listResponse } from '../../utils/listResponse';
import { workflowActivitySchema } from '../models/workflowActivity.schema';
import { workflowActivitiesListQuerySchema } from './list.schema';

export type WorkflowActivitiesListQuery = Partial<{
  annotation: ID;
}> &
  PaginationQuery;

export const list = (query: WorkflowActivitiesListQuery = {}) => {
  return {
    endpoint: `/workflow_activities`,
    method: 'GET',
    responseSchema: listResponse(workflowActivitySchema),
    query: { ...query, includeTotal: true },
    querySchema: workflowActivitiesListQuerySchema.and(
      z.object({ includeTotal: z.boolean().optional() })
    ),
  } as const;
};
